import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { useQuery, useQueryClient } from "react-query";

import moment from 'moment';
import 'moment/locale/el';

import { fetchPosts } from '../../hooks/fetchFromFirebase';

const Posts = () => {

  const queryClient = useQueryClient();

  const { data: dealerPosts, isLoading, error } = useQuery("Dealer posts", fetchPosts);

  if (isLoading) {
    return <div>Loading posts...</div>;
  }

  if (error) {
    return <div>Error loading posts: {error.message}</div>;
  }

  // Calculate CSS class based on number of posts
  const colClass = dealerPosts.length === 3 ? 'm4' : dealerPosts.length === 2 ? 'm6' : 'm12';
  
    return (
      <div className='container padding-vert-40-80'>

        <h3 className='fw-900 ta-center'>Τα νέα μας</h3>

        <div className="row">
          {dealerPosts.length > 0 ? (
            dealerPosts.map((dealerPost, i) => (
              <div key={dealerPost.id} className={`col ${colClass} s12`}>
                  <img
                    className='post-img'
                    src={dealerPost?.image}
                    alt={dealerPost?.title}
                  />
                  <h5 className='fw-900 black'>{dealerPost?.title}</h5>
                  <div className='black'>{dealerPost?.excerpt}</div>
              </div>
            ))
          ) : (
            <div>Δεν βρέθηκαν άρθρα</div>
          )}
        </div>
      </div>
    );
  };
  
  export default Posts;